import { BaseDto } from './base.dto';
import { ModifierDto } from './modifier.dto';
import { ModifierGroupDto } from './modifierGroup.dto';

export class ModifierGroupModifierDto extends BaseDto {
  sequence: number;
  modifierId: number;
  modifierGroupId: number;
  modifier?: ModifierDto;
  modifierGroup: ModifierGroupDto;
}
